import { Button, Tab, Tabs } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useTheme } from '../../../hooks/useTheme';
import ConfigurationInstanceList from './ConfigurationInstanceList';
import CnisConfiguration from './CnisConfiguration/CnisConfiguration';
import styles from './CnisConfiguration/CnisConfiguration.module.css';

function WorkflowConfiguration() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const { theme } = useTheme();

  const handleTabChange = (_: React.SyntheticEvent, activeTab: number) => {
    setSelectedTab(activeTab);
  };

  return (
    <div className={theme ? 'light-theme' : 'dark-theme'}>
      <div
        className={`${styles.settingsContainer} ${styles.settingsContainerPadding}  ${theme ? styles.settingsContainerLight : styles.settingsContainerDark}`}
      >
        <div className={styles.settingsTitleContainer}>
          <div className={styles.settingsTitle}>Workflows Configuration</div>
          <p className={styles.subtitle}>Create and manage the automation workflows configuration.</p>
          <div style={{ marginBottom: '16px' }}>
            <ReactEDSWrapper component={Button} primary onClick={() => navigate('/automation-flows/new')}>
              <i className="icon icon-plus" style={{ marginRight: '8px' }} />
              Create Configuration Instance
            </ReactEDSWrapper>
          </div>
          <Tabs activeTab={selectedTab} onTabChange={handleTabChange}>
            <Tab title="Configuration Instance List">{selectedTab === 0 && <ConfigurationInstanceList />}</Tab>
            <Tab title="CNIS Configuration">{selectedTab === 1 && <CnisConfiguration />}</Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}

export default WorkflowConfiguration;
